import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import '../styles/Auth.css';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [expiredEmail, setExpiredEmail] = useState('');
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await authAPI.verifyEmail(token);
        setStatus('success');
        setMessage(response.data.message);
        setTimeout(() => {
          navigate('/login', { state: { message: t('auth.verifyEmailSuccess') } });
        }, 3000);
      } catch (error) {
        setStatus('error');
        const errorData = error.response?.data;
        setMessage(errorData?.message || t('auth.verifyEmailError'));
        if (errorData?.expired && errorData?.email) {
          setExpiredEmail(errorData.email);
        }
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, navigate]);

  const handleResendVerification = async () => {
    setResendLoading(true);
    setResendMessage('');

    try {
      await authAPI.resendVerification(expiredEmail);
      setResendMessage(t('auth.newLinkSent'));
    } catch (err) {
      setResendMessage(err.response?.data?.message || t('auth.sendError'));
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{t('auth.verifyEmailTitle')}</h2>

        {status === 'loading' && (
          <div className="loading-message" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
            <p>{t('auth.verificationInProgress')}</p>
          </div>
        )}

        {status === 'success' && (
          <div className="success-message" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
            <p style={{ color: '#27ae60', fontWeight: 'bold' }}>{message}</p>
            <p>{t('auth.redirecting')}</p>
          </div>
        )}

        {status === 'error' && (
          <div className="error-section" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>❌</div>
            <div className="error-message">{message}</div>

            {expiredEmail ? (
              <div style={{ marginTop: '20px' }}>
                <p style={{ color: '#666', marginBottom: '15px' }}>
                  {t('auth.verifyEmailResend')}
                </p>
                <button
                  onClick={handleResendVerification}
                  className="btn-secondary"
                  disabled={resendLoading}
                >
                  {resendLoading ? t('common.sending') : t('auth.resendVerification')}
                </button>
                {resendMessage && (
                  <p style={{ marginTop: '10px', color: resendMessage.includes('Erreur') ? '#e74c3c' : '#27ae60' }}>
                    {resendMessage}
                  </p>
                )}
              </div>
            ) : (
              <p style={{ color: '#666', marginTop: '15px' }}>
                {t('auth.verifyEmailExpired')}
              </p>
            )}

            <div style={{ marginTop: '20px' }}>
              <Link to="/login" className="btn-primary">{t('auth.backToLogin')}</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
